import { skipToken, useQuery } from "@tanstack/react-query";
import api from "../../../api";
import urls from "../../../urls";
import type { InvoiceResponse } from "../../../utils/backend-types";

export function useInvoices(projectId?: string | null) {
  return useQuery({
    queryKey: ["invoices", { projectId }],
    queryFn: projectId ? () => fetchInvoices(projectId) : skipToken
  });
}

async function fetchInvoices(projectId: string) {
  const invoicesUrl = urls.api.invoices(projectId);
  const response = await api.get<Array<InvoiceResponse>>(invoicesUrl);
  return response.data;
}
